import React from 'react';

const PoliciesPageConfig = {
	settings: {
		layout: {
			config: {
				adminPage: true
			}
		}
	},
	routes: [
		{
			path: '/admin/policies',
			exact: true,
			component: React.lazy(() => import('./PoliciesPage'))
		},
		{
			path: '/admin/policies/policy/:policyId',
			exact: true,
			component: React.lazy(() => import('./PolicyPage'))
		},
		{
			path: '/admin/policies/create',
			exact: true,
			component: React.lazy(() => import('./PolicyPage'))
		}
	]
};

export default PoliciesPageConfig;
